import styled from "styled-components";

export const PermButton = styled.button`
  padding: 0.5rem 1rem;
  cursor: pointer;
  background-color: #16a34a;
  color: white;
  border: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  font-weight: bold;

  &:hover {
    background-color: #15803d;
  }
`;
